import { render, staticRenderFns } from "./LaunchHome.vue?vue&type=template&id=11a85f9d&scoped=true&"
import script from "./LaunchHome.vue?vue&type=script&lang=js&"
export * from "./LaunchHome.vue?vue&type=script&lang=js&"
import style0 from "./LaunchHome.vue?vue&type=style&index=0&id=11a85f9d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a85f9d",
  null
  
)

export default component.exports